import { appWithTranslation } from 'next-i18next'
import Head from 'next/head'
import ErrorBoundary from 'src/components/fallback/ErrorBoundary'
import { AppContext } from 'src/context'
import { TutorQualityProvider } from 'src/context/TutorQualityContext'
import { AppLayout } from 'src/components/layout'
import 'antd/dist/antd.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import { useRouter } from 'next/router'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { persistor, store } from 'src/redux/store'
import { ModalBannerWhenLogin } from 'src/components/modal/ModalBannerWhenLogin'
import { ModalNotificationHomeWork } from 'src/components/modal/ModalNotificationHomeWork'
import { hasRole, isLoggedIn } from 'src/libs/browser'
import { ModalRemindTutor } from 'src/components/modal/ModalRemindTutor'
import { ModalRemindMonthlyExam } from 'src/components/modal/ModalRemindMonthlyExam'
import { useGetData } from 'src/hooks/useGetData'
import commonApi from 'src/api/commonApi'
import 'src/styles/StudentCare.scss'
import 'src/styles/LogCall.scss'
import 'src/styles/Calendar.scss'
import 'src/styles/global.scss'
import 'src/styles/student.scss'
import 'src/styles/CalendarToday.scss'
import 'src/styles/Responsive.scss'
import 'src/styles/InputRange.scss'
import { useState } from 'react'
import { isMobile } from 'react-device-detect'
import ModalBannerNotifyCalendar from 'src/components/modal/ModalBannerNotifyCalendar'
import { USER_ROLES_ENUM } from 'src/libs/constant'

export const MODE_SHOW_POPUP = {
  MONTHLY_EXERCISE: 'MONTHLY_EXERCISE', // thi tháng
  WEEKLY_EXERCISE: 'WEEKLY_EXERCISE', // btvn
  SPEAKING_EXERCISE: 'SPEAKING_EXERCISE' // thi nói
}

const App = ({ Component, pageProps }) => {
  const title = 'Edupia Tutor - LMS'
  const { asPath } = useRouter()
  const [sidebarIsCollapsed, setSidebarCollapsed] = useState(false)
  const { data: codeShowModal } = useGetData(commonApi.getCodeModal, null, { isDisabled: !isLoggedIn() })
  const isTeacher = hasRole([USER_ROLES_ENUM.EMPLOYEE_TEACHER])
  const showModalRemind = () => {
    const today = new Date()
    const startDate = new Date(2026, 1, 24) // 24-02-2026 (month index starts at 0)
    const endDate = new Date(2026, 2, 1) // 01-03-2026 (month index starts at 0)

    const isInDateRange = today >= startDate && today <= endDate
    switch (codeShowModal) {
      case MODE_SHOW_POPUP.MONTHLY_EXERCISE:
        return isInDateRange ? <ModalBannerNotifyCalendar /> : <ModalRemindMonthlyExam />
      case MODE_SHOW_POPUP.SPEAKING_EXERCISE:
        return <ModalRemindTutor />
      default:
        return <ModalBannerWhenLogin />
    }
  }

  return (
    <>
      <Provider store={store}>
        <PersistGate loading={<div>loading</div>} persistor={persistor}>
          <Head>
            <title>{title}</title>
            <meta
              name='viewport'
              content='width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no'
            />
            <meta property='og:title' content={title} />
          </Head>
          <AppLayout {...pageProps} sidebarIsCollapsed={sidebarIsCollapsed} setSidebarCollapsed={setSidebarCollapsed}>
            <AppContext.Provider value={{}}>
              <TutorQualityProvider>
                <ErrorBoundary url={asPath}>
                  <Component {...pageProps} sidebarIsCollapsed={sidebarIsCollapsed} />
                </ErrorBoundary>
              </TutorQualityProvider>
            </AppContext.Provider>
          </AppLayout>
        </PersistGate>
      </Provider>
      {codeShowModal && !isMobile && isTeacher && showModalRemind()}

      {isLoggedIn() && <ModalNotificationHomeWork />}
    </>
  )
}

export default appWithTranslation(App)
